import Bluebird from 'bluebird';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'prom... Remove this comment to see the full error message
import Queue from 'promise-queue';

// eslint-disable-next-line @trello/no-module-logic
Queue.configure(Bluebird);
